// @flow
import styled from "styled-components";

export const TableFlexBody = styled.div.attrs({
	role: 'rowgroup'
})`
	width: 100%;
`;

export default TableFlexBody;


// WEBPACK FOOTER //
// ./src/components/Table/TableFlexBody.js